//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import * as Utils from "eai-configurator-ui/components/Utils";
import MessageDialog, {
  useMessageDialog,
} from "eai-configurator-ui/components/configuration/dialog/MessageDialog";

const TaskDetailsDialog = ({ taskId, handleClosed }) => {
  const [message, setMessage] = useMessageDialog();
  const [messageProps, setMessageProps] = React.useState(null);
  useEffect(() => {
    if (taskId) {
      fetchDetails();
    }
  }, [taskId]);

  useEffect(() => {
    if (!message.open) {
      handleClosed();
    }
  }, [message.open]);

  const fetchDetails = () => {
    if (taskId) {
      Utils.fetchData("loader/taskDetails?id=" + taskId)
        .then((data) => {
          setMessageProps({ info: true, htmlContents: true });
          setMessage(data.details);
        })
        .catch(function (response) {
          setMessageProps({ error: true });
          Utils.getErrorMessage(response, "Request failed.").then(setMessage);
        });
    }
  };

  const handleCopyToClipboard = () => {
    Utils.copyFormattedHtmlToClipboard(message.description);
  };

  return (
    <MessageDialog
      {...message}
      {...messageProps}
      title="Task Information"
      buttons={[
        <Button color="primary" onClick={handleCopyToClipboard}>
          Copy to clipboard
        </Button>,
      ]}
    />
  );
};
export default TaskDetailsDialog;
